import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useStore } from "../store/useStore";
import { PetalRain } from "../components/Marigold";
import { Stamp } from "../components/Stamp";
import { t } from "../lib/i18n";
import { LANGUAGES } from "../data/languages";
import { BRAND_TAG_CITY } from "../lib/brand";

export default function ThankYou() {
  const lang = useStore((s) => s.language);
  const customerName = useStore((s) => s.customerName);
  const orderId = useStore((s) => s.orderId);
  const reset = useStore((s) => s.reset);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const joinSuffix = searchParams.get("join");
  const isRtl = LANGUAGES.find((l) => l.code === lang)?.rtl;

  useEffect(() => {
    const tm = setTimeout(() => { reset(); navigate("/kiosk"); }, 30000);
    return () => clearTimeout(tm);
  }, [reset, navigate]);

  const reviewsUrl = "https://search.google.com/local/writereview?placeid=ChIJN1t_tDeuEmsRUsoyG83frY4";

  return (
    <div
      className="grain min-h-screen flex flex-col items-center justify-center bg-paper p-10 text-center relative overflow-hidden"
      dir={isRtl ? "rtl" : undefined}
    >
      <PetalRain count={18} />

      <p className="font-mono text-xs tracking-[0.5em] text-mezcal uppercase">{t(lang, "thanks_caption")}</p>
      <p className="font-hand text-4xl text-cactus mt-1">{t(lang, "thanks_handwritten")} {customerName.toLowerCase() || "—"}!</p>

      <div className="relative mt-8">
        <h1 className="font-display font-black text-[10rem] leading-[0.85] tracking-kerned text-ink">
          {joinSuffix ? "EN MESA" : (customerName.toUpperCase() || "GRACIAS")}
        </h1>
        <div className="absolute -top-6 -right-12">
          <Stamp text={joinSuffix ? "ADDED" : "PAID"} color={joinSuffix ? "cactus" : "hibisco"} size={140} rotate={-12} />
        </div>
      </div>

      {joinSuffix && (
        <p className="font-sans text-ink/70 mt-6 max-w-md">
          Tu orden se agregó a la cuenta <span className="font-mono font-bold">{joinSuffix}</span>. Tu mesero la entregará y la cobrará al cierre.
        </p>
      )}

      <div className="mt-10 flex items-center gap-6">
        <span className="font-mono text-xs tracking-widest text-ink/50">{t(lang, "thanks_order")}</span>
        <div
          className="px-6 py-3 bg-ink text-paper font-mono text-3xl font-bold tabular-nums tracking-widest"
          style={{
            clipPath: "polygon(8% 0, 100% 0, 92% 100%, 0 100%)",
            transform: "rotate(-1deg)",
          }}
        >
          № {orderId ? orderId.slice(-4).toUpperCase() : "0000"}
        </div>
      </div>

      <div className="mt-10 max-w-md">
        <p className="font-display font-bold text-3xl">{t(lang, "thanks_show_title")}</p>
        <p className="font-sans text-ink/60 mt-1">{t(lang, "thanks_show_sub")}</p>
      </div>

      <a
        href={reviewsUrl}
        target="_blank"
        rel="noreferrer"
        className="mt-8 inline-flex items-center gap-3 px-7 py-4 rounded-sm bg-cactus text-paper font-display text-xl font-bold tracking-wide shadow-md active:scale-95"
      >
        ★ ★ ★ ★ ★ &nbsp; ¿Nos dejas una reseña?
      </a>

      <div className="mt-12 font-mono text-[10px] tracking-widest text-ink/40">
        {BRAND_TAG_CITY}
      </div>
    </div>
  );
}
